import { kebabCase } from 'lodash'
import { Fulfillment, OrderStatusInfo, ShipmentLabel } from '@/models/interfaces/order'
import { Address } from '@/models/generics'

export function generateTrackingUrl (id: string | undefined, carrier?: string, address: Address = {}) {
  switch (kebabCase(carrier)) {
    case 'dpd':
      return `https://tracking.dpd.de/status/en_US/shipment/${(id || '').substring(0, 3) === 'B2C' ? `MPS${(id || '').substring(3, (id || '').length)}` : id}`
    case 'post-nl':
    case 'postnl':
      return `https://jouw.postnl.nl/track-and-trace/${id}-${address.country_iso}-${address.zipcode}`
    case 'rjp':
      return id
    case 'dhl':
      return id
    case 'packs':
      return id
    case 'ups':
    case 'usps':
      return id
    case 'fedex':
      return id
    default:
      return id
  }
}
